/** Returns the same string but with the first char in lowerCase */
function lowerFirst (str) {
  return str.charAt(0).toLowerCase() + str.slice(1)
}



////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
export class ObjectsWithId {

  constructor (array) {
    if (array) {
      for (var i = 0; i < array.length; i++) {
        this[array[i].id] = array[i]
      }
    } else { // 
    }
  }
  
  get values () {
    return Object.values(this)
  }

  get length () {
    return Object.values(this).length
  }

  forCompanyId (affiliateCompanyId, {affiliates}={}) {
    if (!affiliateCompanyId || Number(affiliateCompanyId) == 0) { // All companies // 2020-10-14 changed from `affiliateCompanyId == '0'` to `Number(affiliateCompanyId) == 0`
      return this
    } else { // 1 company
      // var objClass = this.values[0] ? this.values[0].constructor.name : '' // this doesn't work in prod because the vuejs minimisation changes class names
      var objClass = this.values[0] ? this.values[0]._restVariableName.charAt(0).toUpperCase() + this.values[0]._restVariableName.slice(1) : ''
      console.log('ObjectsWithId, objClass = ', objClass)
      switch (objClass) {
        case 'AffiliateCompanyProxy':
          return this[affiliateCompanyId]
        case 'Lead':
          //console.log('affiliates = ', affiliates)
          !affiliates ? console.log('!!! datamodel.js > forCompany(): Didn\'t pass the affiliates argument!!!') : ''
          return this.filter(lead => affiliates[lead.affiliateId]
                                  && affiliates[lead.affiliateId].affiliateCompanyId == affiliateCompanyId, affiliateCompanyId)
        case 'AffiliateProxy':
          // console.log('case AffiliateProxy, this = ', this)
          // console.log('typeof affiliateCompanyId = ', typeof affiliateCompanyId)
          // console.log('affiliateCompanyId = ', affiliateCompanyId)
          return this.filter(aff => aff.affiliateCompanyId == affiliateCompanyId)
        case 'Payout':
          !affiliates ? console.log('!!! datamodel.js > forCompany(): Didn\'t pass the affiliates argument!!!') : ''
          return this.filter(payout => affiliates[payout.affiliateId]
                                    && affiliates[payout.affiliateId].affiliateCompanyId == affiliateCompanyId, affiliateCompanyId)
        case '':
        default:
          console.log('!!!! WARNING !!!! OjectsWithId.forCompanyId() trying to apply to un expected type: ', this.values[0])
          return new ObjectsWithId()
      }
    }
  }

  filter (fct) {
    var res = []
    // console.log('filter: ', fct)
    this.values.forEach(elem => { fct(elem) ? res.push(elem) : ''} )
    return new ObjectsWithId(res)
  }

  find (fct) {
    for (var i = 0; i < this.values.length; i++) {
      if (fct(this.values[i])) {
        return this.values[i]
      }
    }
    return null
  }

}

////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
export class ObjectWithId {
  static _restVariableNameStatic = ''
  _restVariableName = ''
  id
  deletable
  archived
  dateCreated
  dateModified
  dateArchived

  constructor (obj) {
    this.id =            obj ? (obj.id ?  Number(obj.id) :  null) : null
    this.deletable =     obj ? !!obj.deletable :  false
    this.archived =      obj ? (!!obj.archived) :  false
    this.dateCreated =   obj && obj.dateCreated && (new Date(obj.dateCreated)).toJSON() ? new Date(obj.dateCreated) : undefined
    this.dateModified =   obj && obj.dateModified && (new Date(obj.dateModified)).toJSON() ? new Date(obj.dateModified) : undefined
    this.dateArchived =   obj && obj.dateArchived && (new Date(obj.dateArchived)).toJSON() ? new Date(obj.dateArchived) : undefined
  }

  // Copy values of all attributes of argument obj into This
  update (object) {
    // We first determine if archivedDate needs to be updated
    if (this.archived && !object.archived) {
      this.dateArchived = null
    }
    if (!this.archived && object.archived) {
      this.dateArchived = new Date()
    }
    Object.keys(this).forEach(function(elem) {
      var tmp = eval('object.'+elem)
      //console.log('tmp: ', tmp)
      var tmp2 = ''
      if (typeof tmp == 'boolean' || typeof tmp == 'number' || typeof tmp == 'undefined') {
        //console.log('1')
        tmp2 = 'this.'+elem+'='+tmp
      }
      else {
        if (typeof tmp == 'object') { // Deep copy of object
          //console.log('2')
          tmp2 = 'this.'+elem+'=JSON.parse(JSON.stringify(tmp))'
        } else {
          //console.log('3')
          tmp2 = 'this.'+elem+'=`'+tmp+'`' // String
        }
      }
      //console.log('tmp2: ', tmp2)
      eval(tmp2)
    }, this);
    this.dateModified = new Date()
  }
}

////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
export class DbObject {
  static _restVariableNameStatic = ''
  _restVariableName
  dateCreated
  dateModified
  userWhoCreated
  userWhoModified

  constructor (obj = undefined) {
    this.dateCreated =   obj && obj.dateCreated ? new Date(obj.dateCreated) : undefined
    this.dateModified = obj && obj.dateModified ? new Date(obj.dateModified) : undefined
    this.userWhoCreated = obj ? obj.userWhoCreated : undefined
    this.userWhoModified = obj ? obj.userWhoModified : undefined
  }
}


////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
export class Address {
  addressLine1
  addressLine2
  city
  state
  postalCode
  country

  constructor (obj = undefined) {
    this.addressLine1 = obj ? obj.addressLine1 : ''
    this.addressLine2 = obj ? obj.addressLine2 : ''
    this.city =                 obj ? obj.city : ''
    this.state =               obj ? obj.state : ''
    this.postalCode =     obj ? obj.postalCode : ''
    this.country =           obj ? obj.country : ''
  }

}

////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
export class Person extends ObjectWithId {
  firtName
  lastName
  position
  phone
  email
  email2
  notes

  constructor (obj) {
    super(obj)
    this.id = obj ? (obj.id ?  Number(obj.id) :  null) : null
    this.firstName =               obj ? (obj.firstName || '') : ''
    this.lastName =               obj ? (obj.lastName || '') : ''
    this.position =       obj ? (obj.position || '') : ''
    this.phone =             obj ? (obj.phone || '') : ''
    this.email =             obj ? (obj.email || '') : ''
    this.email2 =             obj ? (obj.email2 || '') : ''
    this.notes =             obj ? (obj.notes || '') : ''
  }
}

////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
export class Affiliate extends Person {
  static _restVariableNameStatic = 'affiliate'
  affiliateCompanyId
  leadsReceived
  leadsClosed
  affiliateAccountId
  incentifyerAccountId

  constructor (obj) {
    super(obj)
    this.affiliateCompanyId = obj ? (obj.affiliateCompanyId || null) : null
    this.leadsReceived = obj ? (obj.leadsReceived || 0) : 0
    this.leadsClosed =     obj ? (obj.leadsClosed || 0) : 0
    this.affiliateAccountId = obj ? (obj.affiliateAccountId || 0) : 0
    this.incentifyerAccountId = obj ? (obj.incentifyerAccountId || 0) : 0
    this._restVariableName = Affiliate._restVariableNameStatic
  }
}


export class AffiliateProxy extends Affiliate {
  static _restVariableNameStatic = 'affiliateProxy'
  affiliateCompanyId
  affiliateAccountId
  leadsReceived
  leadsClosed

  constructor (obj = undefined) {
    super(obj)
    this.affiliateCompanyId =         obj ? obj.affiliateCompanyId || 0 : 0
    if (obj && obj.leadsReceived) this.leadsReceived = obj.leadsReceived
    if (obj && obj.leadsClosed)    this.leadsClosed = obj.leadsClosed
    this.leadsClosed =     obj ? obj.leadsClosed || 0 : 0
    this.affiliateAccountId = obj ? obj.affiliateAccountId || 0 : 0
    this._restVariableName = AffiliateProxy._restVariableNameStatic
  }
}

////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
export class User extends Person {
  static _restVariableNameStatic = 'user'
  password
  profileId
  permissions
  accountId

  constructor (obj) {  
    super(obj)
    this.password =         obj ? (obj.password || '') : ''
    this.profileId =       obj ? (obj.profileId || null) : null
    this.permissions =   obj ? (obj.permissions || []) : []
    this.accountId =       obj ? (obj.accountId || null) : null
    this._restVariableName = User._restVariableNameStatic
  }
}

////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
export class UserProfile extends ObjectWithId {
  static _restVariableNameStatic = 'userProfile'
  name
  permissions

  constructor (obj) {
    super(obj)
    this.name =        obj ? (obj.name || '') : ''
    this.permissions = obj ? (obj.permissions || []) : []
    this._restVariableName = UserProfile._restVariableNameStatic
  }
}



////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
export class CompanyProfile extends DbObject {
  address
  contactName
  email
  companyName
  phone
  about
  domains

  constructor (obj = undefined) {
    super(obj)
    this.address = obj ? new Address(obj.address) : new Address()
    this.contactName =      obj ? obj.contactName : undefined
    this.email =                  obj ? obj.email : undefined
    this.companyName =    obj ? obj.companyName   : undefined
    this.phone =                  obj ? obj.phone : undefined
    this.about =                  obj ? obj.about : undefined
    this.domains =              obj ? obj.domains : []
  }

}


export class AffiliateCompany extends ObjectWithId {
  static _restVariableNameStatic = 'affiliateCompany'
  profile
  status
  color

  constructor (obj = undefined) {
    super(obj)
    this.profile = new CompanyProfile(obj ? obj.profile : null)
    this.status = obj ? obj.status : 'active'
    this.color = obj ? obj.color : undefined
    this._restVariableName = AffiliateCompany._restVariableNameStatic
  }
}


export class AffiliateCompanyProxy extends AffiliateCompany {
  static _restVariableNameStatic = 'affiliateCompanyProxy'
  affiliateCompanyId

  constructor (obj = undefined) {
    super(obj)
    this.affiliateCompanyId = obj ? obj.affiliateCompanyId : undefined
    this.notes = obj ? obj.notes : undefined
    this._restVariableName = AffiliateCompanyProxy._restVariableNameStatic
  }
}

////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
export class Lead extends ObjectWithId {
  static _restVariableNameStatic = 'lead'
  name
  contacts // {name: String, email: String}
  mainContactName
  mainContactEmail
  affiliateId
  affiliateAccountId
  status
  notes
  hot
  dateReceived
  dateClosed
  dateLost
  incentifyerAccountId
  externalId
  value

  static _status = { SUBMITTED: { value: 'submitted', label: 'Submitted' },
                     RECEIVED:  { value: 'received', label: 'Received' },
                     CLOSED:    { value: 'closed', label: 'Closed' },
                     LOST:      { value: 'lost', label: 'Lost' }
  }

  constructor (obj) {
    //console.log('LEAD: ', obj)
    super(obj)
    this.name =                              obj ? (obj.name || '') : ''
    this.contacts =                      obj ? (obj.contacts ?  obj.contacts.filter(e=>true) : []) : []
    this.mainContactName =        obj ? (obj.mainContactName || '') : ''
    this.mainContactEmail =      obj ? (obj.mainContactEmail || '') : ''
    this.affiliateId =                obj ? (obj.affiliateId || obj.affiliateAccountId || null) : null
    this.affiliateAccountId =  obj ? (obj.affiliateAccountId || 0) : 0
    this.status =                          obj ? (obj.status || '') : ''
    this.notes =                            obj ? (obj.notes || '') : ''
    this.hot =                               obj ? !!obj.hot :  false
    this.dateReceived =              obj && obj.dateReceived  && (new Date(obj.dateReceived).toJSON()) ? new Date(obj.dateReceived) : undefined
    this.dateClosed =                  obj && obj.dateClosed  && (new Date(obj.dateClosed).toJSON()) ? new Date(obj.dateClosed) : undefined
    this.dateLost =                      obj && obj.dateLost  && (new Date(obj.dateLost).toJSON()) ? new Date(obj.dateLost) : undefined
    this.incentifyerAccountId = obj ? (obj.incentifyerAccountId || 0) : 0
    this.externalId =                  obj ? (obj.externalId || 0) : 0
    this.value =                            obj ? (obj.value || 0) : 0
    this._restVariableName = Lead._restVariableNameStatic
  }

  update (lead) {
    super.update(lead)
    Object.keys(this).forEach(function(elem) {
      var tmp = eval('lead.'+elem)
      switch (true) {
        case (tmp == null):
          this[elem] = null
          break
        case (typeof tmp == 'boolean'):
        case (typeof tmp == 'number'):
        case (typeof tmp == 'string'):
        case (typeof tmp == 'undefined'):
          this[elem] = tmp
          break;
        case (typeof tmp == 'object' && tmp.constructor && tmp.constructor.name == 'Date'): // TODO: does this actually work when minimized???
          this[elem] = new Date(tmp)
          break;
        case (typeof tmp == 'object' && tmp.constructor && tmp.constructor.name == 'Array'):
          this[elem] = JSON.parse(JSON.stringify(tmp)) // deep copy
          break
        default:
          console.log('!!!!WARNING!!!! datamodel.js:Lead.update(), deep copying unplanned object: ', tmp)
          this[elem] = JSON.parse(JSON.stringify(tmp)) // deep copy
          break
      }
    }, this)
    this.dateModified = new Date()
  }
}

////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
export class Payout extends ObjectWithId {
  static _restVariableNameStatic = 'payout'
  affiliateId
  leadId
  amount
  note
  status
  type
  affiliateAccountId
  incentifyerAccountId

  static _status = { PENDING:                 {value: 'pending', label: 'Pending'},
                     SUBMISSION_REQUESTED:    {value: 'submissionRequested', label: 'Submission Requested'},
                     SUBMITTED:               {value: 'submitted', label: 'Submitted'},
                     PAID:                    {value: 'paid', label: 'Paid'}
  }
  static _type = { LEAD_RECEIVED: {value: 'leadReceived', label: 'Lead Received'},
                   LEAD_CLOSED:   {value: 'leadClosed', label: 'Lead Closed'},
                   MANUAL:        {value: 'manual', label: 'Manual'},
                   WELCOME:       {value: 'welcome', label: 'Welcome'}
  }

  constructor (obj) {
    super(obj)
    this.affiliateId =         obj ? (obj.affiliateId || null) : null
    this.leadId =                   obj ? (obj.leadId || null) : null
    this.amount =           obj ? (Number(obj.amount) || 0) : 0
    this.note =                       obj ? (obj.note || '') : ''
    this.status =                   obj ? (obj.status || Payout._status.PENDING.value) : null
    this.type =                       obj ? (obj.type || '') : ''
    this.affiliateAccountId = obj ? (obj.affiliateAccountId || 0) : 0
    this.incentifyerAccountId = obj ? (obj.incentifyerAccountId || 0) : 0
    this._restVariableName = Payout._restVariableNameStatic
  }

  set amount (amount) {
    console.log('set amount to ', amount)
    this.amount = Number(amount) || amount
  }
}

////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////

export class PaymentCard extends DbObject {
  static _restVariableNameStatic = 'paymentCard'
  static _statuses = ['active', 'inactive', 'expired']
  id
  paymentCardProviderId
  status
  dateActivated
  dateExpiration
  balance

  constructor (obj = undefined) {
    super(obj)
    this.id = obj ? obj.id : undefined
    this.paymentCardProviderId = Number(obj ? obj.paymentCardProviderId : undefined) || undefined
    this.status =                         obj ? obj.status || 'inactive' : 'inactive'
    this.dateActivated =           obj ? obj.dateActivated || undefined : undefined
    this.dateExpiration = obj && obj.dateExpiration ? new Date(obj.dateExpiration) : undefined
    if (obj && obj.balance) this.balance =     obj.balance
    this._restVariableName = PaymentCard._restVariableNameStatic
  }
}




////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
// export class AccountSetup {
//   dateModified
//   companyName
//   address
//   city
//   country
//   state
//   postalCode
//   contactEmail
//   fiscalStartMonth
//   about

//   constructor (obj) {
//     this.dateModified =    obj && obj.dateModified && (new Date(obj.dateModified)).toJSON() ? new Date(obj.dateModified) : undefined
//     this.companyName =     obj && obj.companyName ? obj.companyName : ''
//     this.address =         obj && obj.address ? obj.address : ''
//     this.city =            obj && obj.city ? obj.city : ''
//     this.country =         obj && obj.country ? obj.country : ''
//     this.postalCode =      obj && obj.postalCode ? obj.postalCode : ''
//     this.fiscalStartMonth = obj && obj.fiscalStartMonth ? obj.fiscalStartMonth : ''
//     this.about =           obj && obj.about ? obj.about : ''
//   }
// }


////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
// export class SpiffsLeadsSetup {
//   dateModified
//   manageLeadsMode
//   spiffReceivedLeads
//   spiffForReceivedLead
//   spiffClosedLeads
//   spiffForClosedLead

//   constructor (obj) {
//     this.dateModified = obj && obj.dateModified && (new Date(obj.dateModified)).toJSON() ? new Date(obj.dateModified) : undefined
//     this.manageLeadsMode = obj ? !!obj.manageLeadsMode : false
//     this.spiffReceivedLeads = obj ? !!obj.spiffReceivedLeads : false
//     this.spiffForReceivedLead = obj && Number(obj.spiffForReceivedLead) ? Number(obj.spiffForReceivedLead) : undefined
//     this.spiffClosedLeads = obj ? !!obj.spiffClosedLeads : false
//     this.spiffForClosedLead = obj && Number(obj.spiffForClosedLead) ? Number(obj.spiffForClosedLead) : undefined
//   }
// }


////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
/* export class Invoice extends ObjectWithId {

} */